import { useCategoryStore } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore";
import { findActiveCategoryByUrlIds } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore/findByUrlId";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";
import { ICategoryTreeNodeMetadata } from "@faire/web-api--source/indigofair/data/ICategoryTreeNodeMetadata";
import { useMemo } from "react";
export var useIsHubCategory = function() {
    var _currentC1Category_tree_node_metadata, _currentCategory_tree_node_metadata;
    var categoryModel = useCurrentCategoryModel();
    var categories = useCategoryStore().categories;
    var currentCategory = useMemo(function() {
        return findActiveCategoryByUrlIds(categoryModel.urlIdStrings, categories);
    }, [
        categories,
        categoryModel.urlIdStrings
    ]);
    var c1UrlId = categoryModel.urlId.id;
    var currentC1Category = useMemo(function() {
        return findActiveCategoryByUrlIds([
            c1UrlId
        ], categories);
    }, [
        c1UrlId,
        categories
    ]);
    var currentC1IsHubCategory = (currentC1Category === null || currentC1Category === void 0 ? void 0 : (_currentC1Category_tree_node_metadata = currentC1Category.tree_node_metadata) === null || _currentC1Category_tree_node_metadata === void 0 ? void 0 : _currentC1Category_tree_node_metadata.category_group) === ICategoryTreeNodeMetadata.CategoryGroup.HUB;
    var currentCategoryIsSubcategory = categoryModel.subCategory !== undefined;
    return {
        isHubCategory: (currentCategory === null || currentCategory === void 0 ? void 0 : (_currentCategory_tree_node_metadata = currentCategory.tree_node_metadata) === null || _currentCategory_tree_node_metadata === void 0 ? void 0 : _currentCategory_tree_node_metadata.category_group) === ICategoryTreeNodeMetadata.CategoryGroup.HUB,
        isHubC1Subcategory: currentC1IsHubCategory && currentCategoryIsSubcategory
    };
};
